/* Bear Blanks — koleksiyon kartı swatch'ları + mobil faset drawer + tekil H1 (2026-08-22).
   Idempotent: kart başına da yüklenebilir (arama/öneri bağlamı), koleksiyonda colnav yükler.
   - .bbc-sw tıklaması: kart görseli o rengin varyant görseline döner (data-img/data-srcset), kart linkleri ?variant=ID alır.
   - .collection-sidebar (mobil drawer) altına yapışkan "Show N results" (N = .bch[data-count] ya da sayaç metni).
   - Hero H1 (.bch h1) varsa temanın .section-header-wrapper-collection h1'i DOM'dan kaldırılır (tek H1). */
(function () {
  if (window.__bbcInit) return;
  window.__bbcInit = true;

  function swap(btn) {
    var card = btn.closest('.product-item-block');
    if (!card) return;
    card.querySelectorAll('.bbc-sw.is-on').forEach(function (b) { b.classList.remove('is-on'); });
    btn.classList.add('is-on');
    var img = card.querySelector('.product-card__image:not(.product-card__image--alternate)');
    var src = btn.getAttribute('data-img');
    if (img && src) {
      var srcset = btn.getAttribute('data-srcset') || (src + ' 535w');
      img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
      var mid = btn.getAttribute('data-mid');
      if (mid) img.setAttribute('data-media-id', mid);
      var name = btn.getAttribute('data-name');
      var title = card.querySelector('.product-card__title');
      if (name && title) img.setAttribute('alt', title.textContent.trim() + ' — ' + name);
      card.classList.add('bbc-swapped');
    }
    var vid = btn.getAttribute('data-vid');
    if (vid) {
      card.querySelectorAll('a.product-card__link-image, a.product-card__link-title').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        if (!href) return;
        try {
          var u = new URL(href, window.location.origin);
          u.searchParams.set('variant', vid);
          a.setAttribute('href', u.pathname + u.search);
        } catch (e) { /* yoksay */ }
      });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.bbc-sw') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    swap(btn);
  });

  function initDrawer() {
    var sb = document.querySelector('.collection-sidebar');
    if (!sb || sb.querySelector('.bbc-show')) return;
    var n = '';
    var hero = document.querySelector('.bch[data-count]');
    if (hero) n = hero.getAttribute('data-count') || '';
    if (!n) {
      var pc = document.querySelector('.filters-toolbar__product-count');
      if (pc) { var m = pc.textContent.match(/\d[\d,]*/); n = m ? m[0] : ''; }
    }
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'bbc-show btn btn--primary';
    b.textContent = n ? ('Show ' + n + ' results') : 'Show results';
    b.addEventListener('click', function () {
      var c = sb.querySelector('.close-collection-sidebar');
      if (c) { c.click(); }
      else { sb.classList.remove('show'); document.body.classList.remove('show_overlay'); }
    });
    sb.appendChild(b);
  }

  function fixH1() {
    if (!document.querySelector('.bch h1')) return;
    var h = document.querySelector('.section-header-wrapper-collection h1');
    if (h) h.parentNode.removeChild(h);
  }

  function init() { initDrawer(); fixH1(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
